import { FC, ReactNode, useState } from 'react';
import { Box, IconButton } from '@mui/joy';
import MenuIcon from '@mui/icons-material/Menu';
import Sidebar from 'Components/Sidebar';
import LogoHeader from './Header';
import UploadProgressSnackbar from './UploadProgressSnackbar';
import { useLocation, useMatches } from 'react-router';
import { AppRouteHandle } from '_routes/routeHandle';
import { useTranslation } from 'react-i18next';

interface Props {
  children: ReactNode;
}

const MainLayout: FC<Props> = ({ children }) => {
  const { t } = useTranslation();
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const { pathname } = useLocation();
  const isHomePage = pathname === '/';
  const isFullBleed = useMatches().some(
    (match) => (match.handle as AppRouteHandle | undefined)?.fullBleed
  );

  return (
    <div>
      <LogoHeader />
      <Box
        sx={{ display: 'flex', minHeight: 'calc(100vh - 48px)', width: '100%' }}
      >
        {!isFullBleed && (
          <Sidebar open={sidebarOpen} onClose={() => setSidebarOpen(false)} />
        )}
        <Box
          component="main"
          className={`MainContent p-2${
            isFullBleed ? ' MainContent--full-bleed' : ''
          }`}
        >
          {!isHomePage && !isFullBleed && (
            <IconButton
              variant="outlined"
              color="neutral"
              size="sm"
              onClick={() => setSidebarOpen(true)}
              aria-label={t('Open navigation menu')}
              sx={{
                display: { xs: 'inline-flex', md: 'none' },
                alignSelf: 'flex-start',
                mb: 1,
              }}
            >
              <MenuIcon />
            </IconButton>
          )}
          {children}
        </Box>
      </Box>

      <UploadProgressSnackbar />
    </div>
  );
};

export default MainLayout;
